<template >
  <div> {{ truncate(currentProject.name, {length: 15}) }}  </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Input from '../components/form/Input.vue'
import _ from 'lodash'
import ReLogin from '../views/users/ReLogin.vue'

export default {
  name: 'Projects',
  components: {
    cSwitch,
    InputField: Input,
    ReLogin
  },
  data: function() {
      return {
        showLogin: false,
        changeProjectTo: null,
      }
  },
  computed: {
    projects() {
      return this.$store.getters.projects.filter(p => {
        return p.user_uuid == this.$store.getters.getUser.uuid
      })
    },

    otherProjects() {
      return this.$store.getters.projects.filter(p => {
        return p.user_uuid != this.$store.getters.getUser.uuid
      })
    },

    currentProject() {
      console.log("bbb", this.$store.getters.getCurrentProject)
      return this.$store.getters.getCurrentProject
    }
  },
  methods: {
    avatar(name) {
      return name[0]
    },

    changeProject(uuid) {
      if (this.$store.getters.getCurrentProject.uuid == uuid) {
        return false
      }

      this.changeProjectTo = uuid

      this.showLogin = true
    },

    successLogin() {
      const uuid = this.changeProjectTo
      let project = this.$store.getters.project(uuid)
      if (project.suspension_level > 0) {
        this.$bvModal.msgBoxOk(this.$t('projectSuspended'));
        return
      }

      this.$store.commit("SET_CURRENT_PROJECT", uuid)

      const [ workspace ] = project.workspaces
      localStorage.setItem('current_workspace_uuid', workspace.uuid)

      this.$emit("project_changed")
    },

    truncate: _.truncate
  }
}
</script>
